import React, { useContext } from 'react';
import { Link } from 'react-scroll';
import { ThemeContext } from 'styled-components';
import { AppHeader } from '../styles/header.style';

const Header = ({ onToggleMenu }) => {

    const { logo } = useContext(ThemeContext);

    return (
        <AppHeader>
            <div className="container">
                <div className="row justify-space-between">
                    <div className="logo">
                        <Link
                        to="/"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        className="outside-shadow hover-in-shadow"
                        >
                            {logo}
                        </Link>
                    </div>
                    <div className="menu-icon outside-shadow hover-in-shadow" onClick={onToggleMenu}>
                        <span></span>
                    </div>
                </div>
            </div>
        </AppHeader>
    )
}

export default Header;
